import { getReturnById } from "../services/trucksService.js";
import { buildSteps } from "../pages/Wizard/stepConfig.js";

// Loads this exact return_id's full detail into context, the same way for
// every caller that needs to resume an existing return in the wizard
// (My Filings' Continue, and the "View Error" modal's per-error fix
// buttons) - unambiguous regardless of status, unlike Wizard.jsx's own
// fetch effect (which guesses "whatever this business's current draft is").
// Returns the fetched return so the caller can compute a step index from its
// returnType/amendReason/finalReturn.
export async function seedReturnIntoContext(row, dispatch) {
  const r = await getReturnById(row.id);
  dispatch({ type: "SEED", which: "new" });
  dispatch({ type: "SET_BIZ", patch: { name: row.businessName, ein: row.ein } });
  dispatch({ type: "SET_BUSINESS_ID", businessId: row.businessId });
  dispatch({ type: "SET_RETURN", ...r });
  return r;
}

// 1-based index of stepKey in the step sequence this exact return would
// build (falls back to 1 - the Form step - if stepKey isn't part of this
// return's sequence, e.g. asking for "credits" on a VIN-correction return).
export function resolveStepIndex(r, stepKey) {
  const steps = buildSteps({ returnType: r.returnType, finalReturn: r.finalReturn, amendReason: r.amendReason });
  const idx = steps.findIndex((s) => s.key === stepKey);
  return idx >= 0 ? idx + 1 : 1;
}

// Seeds context for this return, then jumps straight into the wizard at the
// given step key (e.g. "trucks", "credits", "pay") - used by both Continue's
// generic per-return-type guess and the rejection modal's per-error target.
export async function openReturnAtStep(row, stepKey, { dispatch, navigate }) {
  const r = await seedReturnIntoContext(row, dispatch);
  const target = resolveStepIndex(r, stepKey);
  dispatch({ type: "GO_STEP", step: target });
  navigate(`/wizard/${target}`);
  return r;
}

// Seeds context for this return, then sends the filer to the standalone
// Business editor - EIN/name/address aren't a wizard step (see
// stepConfig.js) - with returnTo pointing back at this return's Review step,
// the same returnTo pattern Wizard.jsx's editBusiness already uses.
export async function openBusinessToFix(row, { dispatch, navigate }) {
  const r = await seedReturnIntoContext(row, dispatch);
  const reviewIdx = resolveStepIndex(r, "review");
  navigate("/dashboard/businesses/form", { state: { returnTo: `/wizard/${reviewIdx}` } });
  return r;
}
